'use client'

import { ReactNode, useState } from 'react';
import { IconType } from 'react-icons';
import { TbError404 } from 'react-icons/tb';
import Button from '@/shared/design-system/button/Button';
import { Link } from '@heroui/link';
import { cn } from '@heroui/react';

interface NotFoundProps {
    icon?: IconType;
    title?: string;
    description?: string;
    action?: {
        label: string;
        href: string;
    };
    className?: string;
    children?: ReactNode;
}

export default function NotFound({
    icon: Icon = TbError404,
    title = 'Page Not Found',
    description = 'The page you are looking for could not be found. Please check the URL and try again.',
    action = {
        label: 'Back to Home',
        href: '/app'
    },
    className,
    children
}: NotFoundProps) {

    const [isRetrying, setIsRetrying] = useState(false)

    return (
        <div className={cn(
            'flex flex-col items-center justify-center min-h-[100vh] p-8 pb-24',
            className
        )}>
            {Icon && (
                <div className="w-24 h-24 bg-default-100 rounded-full flex items-center justify-center mb-6">
                    <Icon className="size-12 text-default-500" />
                </div>
            )}
            <h1 className="text-3xl font-bold mb-3">{title}</h1>
            {description && (
                <p className="text-lg text-default-500 text-center max-w-md mb-8">
                    {description}
                </p>
            )}
            {action && (
                <div className='flex items-center gap-5'>
                    <Button
                        onPress={() => {
                            window.location.reload();
                            setIsRetrying(true)
                        }}
                        isLoading={isRetrying}
                        color="primary"
                        size="lg"
                    >
                        Retry
                    </Button>
                    <Button
                        as={Link}
                        href={action.href}
                        color="primary"
                        size="lg"
                        variant='light'
                        isDisabled={isRetrying}
                    >
                        {action.label}
                    </Button> 
                </div>
            )}
            {children}
        </div>
    );
}